import React from 'react';

// Component for displaying Zakat calculation summary
const ZakatSummary = ({ 
  portfolioValue, 
  nisabThreshold, 
  zakatDue, 
  isZakatPayable, 
  selectedCurrency, 
  currencySymbol,
  isLoading,
  error
}) => {
  // Format currency values
  const formatCurrency = (value) => {
    return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  if (isLoading) {
    return (
      <div className="zakat-summary loading">
        <h3>Step 3: Zakat Calculation</h3>
        <div className="loading-spinner">Loading prices...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="zakat-summary error">
        <h3>Step 3: Zakat Calculation</h3>
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="zakat-summary">
      <h3>Step 3: Zakat Calculation</h3>
      
      <div className="summary-card">
        <div className="summary-item">
          <span className="label">Total Portfolio Value:</span>
          <span className="value">
            {currencySymbol}{formatCurrency(portfolioValue)} {selectedCurrency}
          </span>
        </div>
        
        <div className="summary-item">
          <span className="label">Current Nisâb Threshold:</span>
          <span className="value">
            {currencySymbol}{formatCurrency(nisabThreshold)} {selectedCurrency}
          </span>
        </div>
        
        <div className="summary-item">
          <span className="label">Zakat Status:</span>
          <span className={`value status ${isZakatPayable ? 'payable' : 'not-payable'}`}>
            {isZakatPayable ? 'Payable' : 'Not Payable'}
          </span>
        </div>
        
        {isZakatPayable && (
          <div className="summary-item zakat-due">
            <span className="label">Total Zakat Due (2.5%):</span>
            <span className="value">
              {currencySymbol}{formatCurrency(zakatDue)} {selectedCurrency}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ZakatSummary;